var mod = function (n, m) {
    return ((n % m) + m) % m;
};
export default mod;
//# sourceMappingURL=mod.js.map